angular.module('iqxCore')
.service('registrationSvc', function (FormSvc) {
    /*
     * Step 1: Check if user details exist!
     * Step 2: Personel Details Wizard (username, email, password, forename, surname, DOB, address & postcode)
     * Step 3: Select a Division
     * Step 4: Select a Department
     * Step 5: Submit Personel Details
     * Step 6: Department Specific Questions (IQXWeb settings > question groups by department ID - paged)
     * Step 7: Standard Person Questions (possibly paged - maintaince > questionsaires > candidate)
     * Step 8: CV & Photo Uploader
     * Step 9: Done - redirect
     */
    var svc=this
    svc.step=0
    svc.register={}
    svc.hasPreRegistered=false

    svc.resetSvc=function(){
        svc.step=0
        svc.register={}
        svc.backpressed=false
    }

    svc.nextStep=function(scope, goback){
        if (goback===undefined) {
            if(svc.step == 2){
              // submit personal details
              angular.extend(svc.register, {personDetails: scope.theRecord})
            }else if(svc.step == 5){
              // submit department questions
              angular.extend(svc.register, {deptQuestions: scope.tags})
            }else if(svc.step == 6){
              // submit person question
              angular.extend(svc.register, {personQuestions: scope.tags})
            }
            svc.step++
            svc.backpressed=false
        } else {
            if (svc.step!=3) {
                svc.step--
                svc.backpressed=true            
            }

        }
        switch (svc.step) {
            case 0:
                svc.nextStep()
            break

            case 1:

            break

            case 2:

            break

            case 3:

            break

            case 4:

            break

            case 5:

            break


            case 6:

            break

            case 7: // Uploader Page

            break

            case 8: // "Done"

            break
        }
    }
})

.controller('RegisterTempCtrl', function ($scope, FormSvc, registrationSvc, ApiSvc, ApplicationSvc, $location, QuestionnaireSvc, $routeParams, loginSvc) { // EULA & Setup

    if (ApplicationSvc.params.REGISTRATIONTYPE == "normal") { // if its set to normal registration - redirect
        ApplicationSvc.navigate("candregister")      
    }

    FormSvc.setOptions($scope,{
        autoEdit:true,
        notLoggedIn:true
    })

    $scope.regSvc=registrationSvc
    $scope.step=$scope.regSvc.step
    $scope.queryString={}

    if (ApplicationSvc.currentUser.UserClass!='CANDIDATE') {
        loginSvc.setLoggedOut()
    } else {
        if (ApplicationSvc.currentUser.UserClass=='CANDIDATE') {
            ApplicationSvc.currentUser.UserClass="PRE-CANDIDATE"

            registrationSvc.step=3 // User has a stub record, send them to the division selector

            if ($routeParams.continuefrom) {
                registrationSvc.step=$routeParams.continuefrom
            }
        }
    }

    $scope.next=function(){
        $scope.regSvc.nextStep($scope)
    }

    $scope.wizardBack=function(){
        registrationSvc.nextStep($scope, 1)
    }

    { // init
        var fnToString = registrationSvc.nextStep.toString();
        var fnBody = fnToString.match(/function[^{]+\{([\s\S]*)\}$/)[1];
        var count = fnBody.match(/case/g).length; //should equal 2
        if ($scope.isSwitchedOn('WIZARDUPLOADERCV') || $scope.isSwitchedOn('WIZARDUPLOADERPHOTO')) {
            $scope.steps=8 // ? this may change
        } else {
            $scope.steps=7 // ? this may change
        }       
        FormSvc.setEditing($scope, false)
    }
})

.controller('RegisterWizardStep0And1Ctrl', function ($scope, FormSvc, $location, $routeParams, registrationSvc) { // Check Login Exists
    FormSvc.setOptions($scope,{
        fetchAPI:{/* Empty Fetch */},
        saveAPI:{/* Empty Save */},
        autoEdit:true,
        notLoggedIn:true,
        saveCleanFields:true
    })

    $scope.checkLogin=function(login){
        return $scope.fetch({
            fetchAPI:'callresult_/NetCheckLoginExists?pLogin='+login,
            fetchTarget:'logincheckrtrn',
            multiRow:false,
            notLoggedIn:true
        })
        .then(function(){
            switch ($scope.logincheckrtrn.pResult) {
                case '1:~Registration':
                    registrationSvc.register.username=login
                    registrationSvc.nextStep($scope)
                break
                case '0:~Login':
                    $location.url("login?exists=true")
                break
                default:
                    FormSvc.alert(false, $scope.logincheckrtrn.pResult, "error")
                break
            }
        })
    }
})

.controller('RegisterWizardStep2Ctrl', function($scope, FormSvc, ApplicationSvc, loginSvc, registrationSvc, $routeParams, ApiSvc){ // Personal Sign up Details
    // this will be changed to the standard register (without custom q's - i think)
    FormSvc.setOptions($scope,{
        fetchAPI:{/* Empty Fetch */},
        saveAPI:'register/candidate',
        savePrefix:'p',
        autoEdit:true,
        notLoggedIn:true,
        saveCleanFields:true
    })

    // 2 hidden fields for email and repeat email

    $scope.saveButtonCaption="Continue"
    $scope.extraFields={}
    $scope.SourceVisible=true
    $scope.passwordOpts()
    $scope.autocompleteResults = []
    $scope.autocompleteEnabled = $scope.params.ADDRESSLOOKUP
    $scope.addressLookupPlaceholder = $scope.autocompleteEnabled ? 'Start typing your address or postcode' : ''
    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    $scope.update=function () {  // Over-ride the default update() called by the Register button
        if ($scope.theRecord.NINumber) {
            $scope.theRecord.NINumber = $scope.theRecord.NINumber.replace(/ /g,'')
        }
        FormSvc.setSubmitted($scope,true)
        if ($scope.theForm.$valid){
            return FormSvc.update($scope,true)  // Save only - do not do the fetch
            .then(function(res) {
                ApplicationSvc.isEditing=false
                return loginSvc.setLoggedIn(res, true)
                .then(function(loginstatus){
                  ApplicationSvc.onRegisterPage = true
                  ApplicationSvc.currentUser.UserClass="PRE-CANDIDATE"
                })
            })
            .then(function(){ // save extra fields if needed!
                if ($scope.params.REGSOURCESELECT) {
                    var extraFields = {}
                    extraFields.pSourceID = $scope.extraFields.SourceID
                    if ($scope.extraFields.Experience) {
                        extraFields.pExperience = $scope.extraFields.Experience
                    }
                    return $scope.exec('call/NetCandidateSaveQuestions', extraFields)
                } else {
                    return true
                }
            })
            .then(function(){
                registrationSvc.nextStep($scope)
            })
        } else {
          FormSvc.alert(false, "Please check that you have completed all the required fields and there are no invalid values", "error")
        }
    }

    $scope.addressAutocomplete = async function (input) {
        if ($scope.autocompleteEnabled === false) { return }
        $scope.autocompleteResults[input] = null
        $scope.autocompleteResults[input] = await ApiSvc.exec($scope, 'addressLookup/autocomplete', { autocomplete: $scope.theRecord[input] }, true)
            .catch((e) => {
                $scope.autocompleteResults = []
                $scope.autocompleteEnabled = false
            })
    }

    $scope.selectAddress = async function (address) {
        if ($scope.autocompleteEnabled === false) { return }
        $scope.autocompleteResults = []
        var fullAddress = await ApiSvc.exec($scope, 'addressLookup/getFull', { udprn: address.udprn }, true)
            .catch((e) => {
                $scope.autocompleteResults = []
                $scope.autocompleteEnabled = false
            })
        updateAddressFields(fullAddress.IQXResult.Row)
    }

    function updateAddressFields(address) {
        $scope.theRecord.Addr1 = address.line_1
        $scope.theRecord.Addr2 = address.line_2
        $scope.theRecord.Addr3 = address.line_3
        $scope.theRecord.Town = address.post_town
        if ($scope.params.INCCOUNTY === true) {
            $scope.theRecord.County = address.county
        }
        if ($scope.params.INCCOUNTRY === true || $scope.params.OVERRIDECOUNTRY) {
            $scope.theRecord.Country = address.country
        }
        $scope.theRecord.Postcode = address.postcode
    }

    $scope.getRequiredFields=function(){
      return ApiSvc.fetch($scope,{
        fetchAPI:'callresult_/NetGetRegRequired',
        fetchTarget:'requiredFields',
        multiRow:false,
        notLoggedIn:true
      })
        .then(function(){
          $scope.requiredFields = JSON.parse($scope.requiredFields.JSON)
        })
    }

    $scope.getSourceDetails=function(){
       return $scope.fetch({
            fetchAPI:'callresult_/NetCandidateSourceSelect',
            fetchTarget:'sourceSelect',
            multiRow:true,
            notLoggedIn:true
        })
    }

    $scope.getRequiredFields()
    .then(function(){
      $scope.fetch()  // Initialise
    })    
    .then(function(){
        $scope.theRecord.UserName=registrationSvc.register.username
        $scope.theRecord.Email=registrationSvc.register.username
        $scope.theRecord.RepeatEmail=registrationSvc.register.username

        if ($scope.params.REGSOURCESELECT) {
            $scope.getSourceDetails()
            .then(function(){
                if ($routeParams.source) {
                    $scope.SourceVisible=false
                    $scope.extraFields.SourceID = $routeParams.source
                }
            })
        }

        angular.extend($scope.theRecord, registrationSvc.register.personDetails)
    })
})

.controller('RegisterWizardStep3Ctrl', function($scope, FormSvc, ApplicationSvc, registrationSvc){ // Divisions
    ApplicationSvc.onRegisterPage = true
    FormSvc.setOptions($scope,{/* No Options Needed - Just neeed the Svc */})

    $scope.checkDivision=function(){
        // Check if the user has already selected a division, if they have
        // send them to the department selector
        // otherwise, let them continue
        return $scope.fetch({
            fetchAPI:'callresult/NetCandidateDivisionID',
            fetchTarget:'selectedDivision',
            multiRow:false,
            fetchWithPersonID:true
        })
        .then(function(){
            if ( ($scope.selectedDivision.divisionID != null && $scope.selectedDivision.divisionID != "") ) {
                return $scope.selectDivision($scope.selectedDivision.divisionID)
            }
        })
    }

    $scope.iconExists=function(icon){
        if(icon) { 
            var url = '/assets/registericons/'+icon+'.png'
            var request = new XMLHttpRequest()
            request.open('HEAD', url, false)
            request.send()
            if(request.status == 200 && request.responseURL.includes('.png')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    $scope.getDivisions=function(){
        return $scope.fetch({
            fetchAPI:'callresult/NetDivisionList',
            fetchTarget:'DivisionList',
            multiRow:true
        }).then(function(){
            // check for icons and store flag in array for better render performance
            angular.forEach($scope.DivisionList,function(d){d.iconExists=$scope.iconExists(d.DivisionID)})
        })
    }

    $scope.selectDivision=function(DIV){
        registrationSvc.register.division=DIV
        registrationSvc.nextStep($scope)
    }

    $scope.getDivisions() 
    .then(function(){
        $scope.checkDivision()
    })
})

.controller('RegisterWizardStep4Ctrl', function($scope, FormSvc, registrationSvc, $location, $http, ApiSvc, $sce, ApplicationSvc, LanguageSvc){ // Departments
    $scope.TANDCDisplayTypeHTML = "txt"
    FormSvc.setOptions($scope,{/* No Options Needed - Just neeed the Svc */})

    $scope.iconExists=function(icon){
        if(icon) { 
            var url = '/assets/registericons/'+icon+'.png'
            var request = new XMLHttpRequest()
            request.open('HEAD', url, false)
            request.send()
            if(request.status == 200 && request.responseURL.includes('.png')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    $scope.getDepartments=function(Division){
        return $scope.fetch({
            fetchAPI:'callresult/NetDepartmentList?pDivisionID='+registrationSvc.register.division,
            fetchTarget:'DepartmentList',
            multiRow:true
        }).then(function(){
            // check for icons and store flag in array for better render performance
            angular.forEach($scope.DepartmentList,function(d){d.iconExists=$scope.iconExists(d.DepartmentID)})
        })
    }

    $scope.getFile=function(termsAndConditionsDocument){
        $scope.TANDCsDocID = termsAndConditionsDocument
        $http.get('/api/document/doxi',{params:{id:$scope.TANDCsDocID}})
        .then(function(res){
            $http.get('/api/document/download?doxi='+res.data)
            .then(function(tAndCHTML){
                let headers = tAndCHTML.headers()
                if ((new RegExp('.html')).test(headers['content-disposition'])) { $scope.TANDCDisplayTypeHTML = "html" }
                $scope.PDFcontent = $sce.trustAsHtml(tAndCHTML.data)
            }, function(error){
                if (error.status = 404) {
                    registrationSvc.nextStep()
                } else {
                    FormSvc.alert("Error", "Error ["+error.status+"] " + error.data, "error")
                }                
            })
        })
        .catch(function(err) {
            FormSvc.alert("Error", err.data, "error")
        })
    }

    $scope.selectDepartment=function(dept){
        $scope.showTermsAndConditions=false
        let data={"department":dept.DepartmentID, "deptName":dept.DepartmentName}
        data.temp=false
        data.perm=false
        return FormSvc.modalForm($scope,'deptTempOrPerm',data,'md',{label:'col-sm-3', data:'col-sm-7'})
        .then(function(x){
            if (x.temp == false && x.perm == false) {
                FormSvc.alert(false, "You have to select at least one " + LanguageSvc.lang.candidate.department +".", "error")
            } else {
                registrationSvc.register.DepartmentName=x.deptName
                registrationSvc.register.department=x.department
                registrationSvc.register.departmentTemp=x.temp
                registrationSvc.register.departmentPerm=x.perm

                if ($scope.isSwitchedOn('SHOWTANDCONREG')) {
                    $scope.showTermsAndConditions=true
                    return $scope.exec('call/NetCandidateDoTermsAndConditions',{
                        pStage:'O',
                        pDivisionID:registrationSvc.register.division,
                        pDepartmentID:registrationSvc.register.department,
                        pPersonID:ApplicationSvc.currentUser.personID
                    })
                    .then(function(r){
                        $scope.TermsAndConditions = r.IQXResult.IQXSuccess.attrs.id
                        return $scope.getFile($scope.TermsAndConditions)
                    })
                    .catch(function(err){
                        // May need to do something else here
                        registrationSvc.nextStep()
                    })
                } else {
                    registrationSvc.nextStep()
                }
            }
        })
    }

    $scope.termsAndCondititions=function(accepted){
        if (accepted) {
            return $scope.fetch({
                fetchAPI:'callresult/NetCandidateDoTermsAndConditions?pStage=A&pDocumentID='+$scope.TANDCsDocID,
                fetchTarget:'AcceptTermsAndConditions',
                multiRow:false,
                fetchWithPersonID:true
            })
            .then(function(){
                registrationSvc.nextStep()
            })
        } else {
            return $scope.fetch({
                fetchAPI:'callresult/NetCandidateDoTermsAndConditions?pStage=R',
                fetchTarget:'RejectedTermsAndConditions',
                multiRow:false,
                fetchWithPersonID:true
            })
            .then(function(){
                $scope.logout()
                $location.url("login?registerRefused=true")
            })

        }
    }

    // Init
    $scope.getDepartments()
})

.controller('RegisterWizardStep5Ctrl', function($scope, FormSvc, registrationSvc, ApplicationSvc, $timeout){ // Department Questions
    $scope.ChosenDepartmentName=registrationSvc.register.DepartmentName
    if ($scope.isSwitchedOn('WIZARDQALT')) {
        FormSvc.setOptions($scope,{
            fetchAPI:{/* Empty Fetch */},
            saveAPI:'call/NetCandidateDepartmentRegister',
            notLoggedIn:false, // New candidate so obviously not yet logged in
            autoEdit:true, // Switch form straight to edit mode
            saveCleanFields:true, // All fields sent, whether or not dirty
            questionnaire:{
                tagTarget:'tags',
                tagLocation:'A'+registrationSvc.register.department,
                postVar:'qanswers',
                displayGroup:'?CANDDEPT_'+registrationSvc.register.department
            }
        })
    } else {
        FormSvc.setOptions($scope,{
            fetchAPI:{/* Empty Fetch */},
            saveAPI:'call/NetCandidateDepartmentRegister',
            notLoggedIn:false, // New candidate so obviously not yet logged in
            autoEdit:true, // Switch form straight to edit mode
            saveCleanFields:true, // All fields sent, whether or not dirty
            questionnaire:{
                tagTarget:'tags',
                displayGroup:registrationSvc.register.department+'_1',
                tagLocation:'P',
                postVar:'qanswers'
            }
        })
    }

    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
          start = 0;
        }

        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      };
    }

    // goes in as temp

    $scope.update=function () {  // Over-ride the default update() called by the Register button
        $scope.theRecord={
            'pdepartmentid':registrationSvc.register.department,
            'ptemp':(registrationSvc.register.departmentTemp ? 1 : 0),
            'pperm':(registrationSvc.register.departmentPerm ? 1 : 0),
            'pPersonID': ApplicationSvc.currentUser.personID
        }
        FormSvc.setSubmitted($scope,true)
        if ($scope.theForm.$valid){
            return FormSvc.update($scope,true)  // Save only - do not do the fetch
            .then(function(res) {
                $scope.exec('call/NetCandidateDivisionRegister',{
                    pPersonID: ApplicationSvc.currentUser.personID,
                    pDivisionID: registrationSvc.register.division
                })        
                registrationSvc.nextStep($scope)                
            })
        } else {
          FormSvc.alert(false, "Please check that you have completed all the required fields and there are no invalid values", "error")
        }
    }

    $scope.ObjSize = function(obj) {
        var size = 0, key
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++
        }
        return size
    }

    $scope.fetch()
    .then(function(){
        if ($scope.ObjSize($scope.tags) == $scope.ObjSize(registrationSvc.register.deptQuestions) && $scope.tags[0]) {
            if ($scope.tags[0].id == registrationSvc.register.deptQuestions[0].id) {
                angular.extend($scope.tags, registrationSvc.register.deptQuestions)
            }
        }
    })
})

.controller('RegisterWizardStep6Ctrl', function($scope, FormSvc, registrationSvc, $timeout, ApplicationSvc){ // Person Questions
    FormSvc.setOptions($scope,{
        fetchAPI:{/* Empty Fetch */},
        saveAPI:'call/NetCandidateSaveQuestions',
        savePrefix:'p',
        notLoggedIn:false, // New candidate so obviously not yet logged in
        autoEdit:true, // Switch form straight to edit mode
        saveCleanFields:true, // All fields sent, whether or not dirty
        primaryKey:'PersonID',
        saveWithPersonID:true,
        questionnaire:{
            tagTarget:'tags',
            tagLocation:'P',
            id:'',
            postVar:'qanswers',
            displayGroup:'?CANDIDATE'
        }
    })
    $scope.saveButtonCaption="Continue"

    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
          start = 0
        }

        if (start + search.length > this.length) {
          return false
        } else {
          return this.indexOf(search, start) !== -1
        }
      }
    }

    $scope.update=function () {  // Over-ride the default update() called by the Register button
        FormSvc.setSubmitted($scope,true)
        if ($scope.theForm.$valid){
            return FormSvc.update($scope,false, false)
            .then(function(){
                registrationSvc.nextStep($scope)
            })            
        } else {
          FormSvc.alert(false, "Please check that you have completed all the required fields and there are no invalid values", "error")
        }
    }

     $scope.ObjSize = function(obj) {
         var size = 0, key
         for (key in obj) {
             if (obj.hasOwnProperty(key)) size++
         }
         return size
     }

    $scope.fetch()
     .then(function(){
         if ($scope.ObjSize($scope.tags) == $scope.ObjSize(registrationSvc.register.personQuestions) && $scope.tags[0]) {
             if ($scope.tags[0].id == registrationSvc.register.personQuestions[0].id) {
                 angular.extend($scope.tags, registrationSvc.register.personQuestions)
             }
         }
     })
    .then(function(){
        angular.extend($scope.tags, registrationSvc.register.personQuestions)
    })
})

.controller('RegisterWizardStep7Ctrl', function($scope, FormSvc, registrationSvc, ApplicationSvc, ApiSvc){ // File Uploader
    if ($scope.isSwitchedOn('WIZARDUPLOADERCV') || $scope.isSwitchedOn('WIZARDUPLOADERPHOTO')) {
        $scope.allowCVUpload=$scope.isSwitchedOn('WIZARDUPLOADERCV')
        $scope.allowPhotoUpload=$scope.isSwitchedOn('WIZARDUPLOADERPHOTO')

        if ($scope.allowCVUpload) { $scope.CVUploadNotDone=true } else { $scope.CVUploadNotDone=false }
        if ($scope.allowPhotoUpload) { $scope.ImageUploadNotDone=true } else { $scope.ImageUploadNotDone=false }    

        if ($scope.allowCVUpload && $scope.allowPhotoUpload) {
            $scope.allow='all'
        }   
    } else {
        $scope.ImageUploadNotDone=false
        $scope.CVUploadNotDone=false
        registrationSvc.nextStep($scope)
    }

    $scope.next=function(){
        var err=false
        if ($scope.isSwitchedOn('WIZARDUPLOADERREQCV') || $scope.isSwitchedOn('WIZARDUPLOADEREQPHOT')) {
            if ($scope.isSwitchedOn('WIZARDUPLOADERREQCV')) {
                if ($scope.CVUploadNotDone) {
                    FormSvc.alert(false, "A CV is required, please upload a CV.", "error")
                    err=true
                }
            }

            if ($scope.isSwitchedOn('WIZARDUPLOADEREQPHOT')) {
                if ($scope.ImageUploadNotDone) {
                    FormSvc.alert(false, "A photo is required, please upload a photo.", "error")
                    err=true
                }
            }

            if (!err) {
                registrationSvc.nextStep($scope)
            }
        } else {
            registrationSvc.nextStep($scope)
        }
    }
})

.controller('RegisterWizardStep7CVCtrl', function($scope, FormSvc, registrationSvc, $window, $q, $timeout, $http, ApplicationSvc, ApiSvc, QuestionnaireSvc, Upload){ // File Uploader PHOTO

    FormSvc.setOptions($scope,{fetchAPI:{}, doNotPreventNav:true, autoEdit:true})

    $scope.params.PDFCVDOCTYPE = $scope.params.PDFCVDOCTYPE || ''

    if (!$scope.params.PDFCVDOCTYPE) {
        $scope.uploadTypes={
            "doc":{
                "value":"primary_cv",
                "descrip":"Word Document (.doc, .docx)"
            }
        }
    } else {
        $scope.uploadTypes={
            "doc":{
                "value":"primary_cv",
                "descrip":"Word Document (.doc, .docx)"
            },
            "pdf":{
                "value":$scope.params.PDFCVDOCTYPE,
                "descrip":"Portable Document Format (.pdf)"
            }
        }
    }

    $scope.docType="primary_cv"

    $scope.uploadSelect = function (files, file, event) {
        $scope.theForm.CVfile.$touched = true
    }

    $scope.uploadComplete = function () {
        $scope.reset()
        if ($scope.theForm) { // Without this - the form will display "no file selected" error after upload complete!
            $scope.theForm.CVfile.$touched = false
        }
        $scope.setEditing(true)  // bodge to allow next upload
        ApplicationSvc.preventNavIfEditing=false // allows you to move to new page without error after changing image
        $scope.uploadProgress = ''
        $scope.uploadError = ''
        $scope.theRecord = {}
    }

    $scope.uploadFileName = function () {
        if ($scope.theRecord.CVfile) {
            return $scope.theRecord.CVfile.name
        } else {
            return 'Select CV'
        }
    }

    $scope.triggerUploader=function(){
        document.getElementById('CVfile').click()
    }

    $scope.showUploadProgress = function (evt) {
            var s = "Uploading ..."
            if (evt && evt.total) {  // progress callback
                s = s + parseInt(100.0 * evt.loaded / evt.total) + '%'
            }
            $scope.uploadProgress = s
    }

    $scope.uploadExecute = function () {
            $scope.setSubmitted(true) // Ensure all validation errors appear
            $scope.uploadError = ''
            $scope.showUploadProgress()
            Upload.upload({
                url             : '/api/document/upload',
                file            : $scope.theRecord.CVfile,
                fileFormDataName: 'file',
                headers         : {'X-Auth': ApplicationSvc.currentUser.token},
                fields:{
                    'Type':$scope.docType,
                    'Description':"CV",
                    'PersonID':ApplicationSvc.currentUser.personID
                }
            })
                .then(function (res) {
                    ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
                    $scope.uploadProgress = "Upload Complete"
                    return $timeout(function () {
                    }, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
                }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
                .then(function () {
                    $scope.$parent.$parent.CVUploadNotDone=false
                    $scope.CVUploadNotDone=false
                    $scope.uploadComplete()
                })
                .catch(function (err) {
                    $scope.uploadProgress = ''
                    return $q.reject($scope.uploadError = ApiSvc.ExtractError(err))
                })
    }

    $scope.uploadComplete()
})

.controller('RegisterWizardStep7PHOTOCtrl', function($scope, FormSvc, registrationSvc, $window, $q, $timeout, $http, ApplicationSvc, ApiSvc, QuestionnaireSvc, Upload){ // File Uploader Photo

    FormSvc.setOptions($scope,{fetchAPI:{}, doNotPreventNav:true, autoEdit:true})

    $scope.uploadSelect = function (files, file, event) {
        $scope.theForm.file.$touched = true
    }

    $scope.uploadComplete = function () {
        $scope.reset()
        if ($scope.theForm) { // Without this - the form will display "no file selected" error after upload complete!
            $scope.theForm.file.$touched = false
        }
        $scope.setEditing(true)  // bodge to allow next upload
        ApplicationSvc.preventNavIfEditing=false // allows you to move to new page without error after changing image
        $scope.uploadProgress = ''
        $scope.uploadError = ''
        $scope.theRecord = {}
    }

    $scope.uploadFileName = function () {
        if ($scope.theRecord.file) {
            return $scope.theRecord.file.name
        } else {
            return 'Select Image'
        }
    }

    $scope.triggerUploader=function(){
        document.getElementById('file').click()
    }

    $scope.showUploadProgress = function (evt) {
            var s = "Uploading ..."
            if (evt && evt.total) {  // progress callback
                s = s + parseInt(100.0 * evt.loaded / evt.total) + '%'
            }
            $scope.uploadProgress = s
    }

    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
          start = 0;
        }

        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      };
    }

    $scope.uploadExecute = function () {
            $scope.setSubmitted(true) // Ensure all validation errors appear
            if (!$scope.theRecord.file.type.includes("image/")){
                return
            }
            $scope.uploadError = ''
            $scope.showUploadProgress()
            Upload.upload({
                url             : '/api/document/upload',
                file            : $scope.theRecord.file,
                fileFormDataName: 'file',
                headers         : {'X-Auth': ApplicationSvc.currentUser.token},
                fields:{
                    'Type':'primary_photo',
                    'Description':"Photo",
                    'PersonID':ApplicationSvc.currentUser.personID
                }
            })
                .then(function (res) {
                    ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
                    $scope.uploadProgress = "Upload Complete"
                    return $timeout(function () {
                    }, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
                }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
                .then(function () {
                    $scope.$parent.$parent.ImageUploadNotDone=false
                    $scope.ImageUploadNotDone=false
                    $scope.uploadComplete()
                })
                .catch(function (err) {
                    $scope.uploadProgress = ''
                    return $q.reject($scope.uploadError = ApiSvc.ExtractError(err))
                })
    }

    $scope.uploadComplete()
})

.controller('RegisterWizardStep8Ctrl', function($scope, FormSvc, registrationSvc, ApplicationSvc, $location){ // Handles "DONE"
    $scope.exec('call/NetCandidateSetRegistrationComplete',{
        pPersonID: ApplicationSvc.currentUser.personID
    })
    .then(function(){
      ApplicationSvc.currentUser.UserClass='CANDIDATE'
      ApplicationSvc.onRegisterPage = false
      $location.url("home")
    })
})
